module.exports = __webpack_public_path__ + "img/404.4c18c4fa.jpg";